class Accordion {
    constructor() {
        this.isAcc = false;
    }

    init() {
        this.isAcc = document.body.classList.contains('is-acc') ? true : false;
        // acc
        const acc01 = new azlib.SimpleAccordion();
    }
}

const accordion = new Accordion();

document.addEventListener('DOMContentLoaded', () => {
    accordion.init();
});